import React from 'react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { key: 'activity', label: 'Activity Log', path: '/admin/activity-logs' },
  { key: 'member', label: 'Member Activity', path: '/admin/member-activity' },
];

const AdminLogsTabs = ({ active }) => (
  <nav aria-label="Admin logs" className="border-b border-slate-200" data-testid="admin-logs-tabs">
    <div className="flex gap-6" role="tablist">
      {tabs.map((tab) => (
        <NavLink
          key={tab.key}
          to={tab.path}
          role="tab"
          aria-selected={active === tab.key}
          data-testid={`admin-logs-tab-${tab.key}`}
          className={`border-b-2 px-1 pb-3 text-sm font-medium transition-colors ${
            active === tab.key
              ? 'border-blue-600 text-blue-700'
              : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800'
          }`}
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default AdminLogsTabs;
